import { Injector } from "@angular/core";
import { ListView } from "../../Data/ListView";
import { BaseNode } from "../BaseNode";

export class MeddraResultList extends BaseNode {
    constructor(injector: Injector) {
       super(injector,new ListView(),"Results"); 
    }

    getHeaders(): string[] {
        return ['Results Found'];
    }
    
}